import { DealTermChange } from "./deal-term-change.js";
import {AjaxRequest} from "../../utils/ajax-request.js";

export class DealChangeForm {

	constructor() {
		this._node = null;
		this._action = "";
		this._token = "";
		this._calendar = null;
		this._calendarInput = null;
		this._calendarSurchargeInput = null;
		this._elements = {};
	}


	init(node) {
		let self = this;
		self._node = node;

		if (!self._node) {
			return;
		}

		self._action = self._node.action?.replace(/\/$/, '') || '';
		self._token = self._node.dataset.token;

		self._calendar = self._node.querySelector('.js-deal-term-change__calendar');
		self._calendarInput = self._node.querySelector('.js-deal-term-change__input');
		self._calendarSurchargeInput = self._node.querySelector('.js-deal-term-change__surcharge-input');

		self.datepickerRender(self._calendar);

		self._initElements();
		self._bindEvents();
	}

	datepickerRender(_calendar) {
		const self = this;

		const url = new URL(_calendar.dataset.url);
		const selectedVariant = _calendar.dataset.variant;
		const selectedRoom = _calendar.dataset.room;
		const transaction = _calendar.dataset.transaction;

		if (!selectedVariant) {
			return;
		}

		// get availability
		url.searchParams.append("variant_id", selectedVariant);
		url.searchParams.append("transaction_id", transaction);

		if (selectedRoom) {
			url.searchParams.append("room_id", selectedRoom);
		}

		AjaxRequest.create(url.toString())
			.then((result) => self.datepickerPlugin(result))
			.catch((err) => AjaxRequest.handleError(err));
	}


	datepickerPlugin(_response) {
		const self = this;
		const _selector = self._calendar;
		const minDate = _response.minDate;
		const maxDate = _response.maxDate;
		const available = _response.available;
		const checkin = _response.checkin;
		// consider only checkin dates if the checkin dates array is smaller than available dates
		// meaning we actually have a limited amount of checkin days
		const considerCheckin = checkin.length < available.length;
		const unavailable = _response.unavailable;
		const disabled = _response.unavailable.filter((d) => {
			return !_response.checkout.includes(d);
		});
		const checkout = _response.checkout;
		const selectable = _response.selectable;
		const days = self.fetchDays(_selector);
		const icons = _response.icons;
		let current = null;

		const arrowRightHtml =
			`<span class="icon-svg icon-svg__icon-arrow-circle-right" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="` +
			icons +
			`#icon-arrow-circle-right"></use></svg></span>`;
		const arrowLeftHtml =
			`<span class="icon-svg icon-svg__icon-arrow-circle-left" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="` +
			icons +
			`#icon-arrow-circle-left"></use></svg></span>`;

		let fp = window.flatpickr(_selector, {
			dateFormat: "Y-m-d",
			inline: true,
			static: true,
			minDate: minDate,
			maxDate: maxDate,
			nextArrow: arrowRightHtml,
			prevArrow: arrowLeftHtml,
			// 'disable': unavailable,
			disable: disabled,
			clickOpens: true,
			locale: {
				firstDayOfWeek: 2,
			},
			onChange: function (selectedDates, dateStr, instance) {
				let selectDates;

				/* if user clicked on the same date as before toggle selection off */
				if (current === dateStr) {
					selectDates = {
						selected: [],
						isAvailable: false,
					};

					current = null;
				} else {
					selectDates = self.selectDates(
						dateStr,
						days,
						available,
						checkin,
						checkout,
						considerCheckin,
						instance
					);
					current = dateStr;
				}

				self.hoverEvent(days, available, checkin, checkout, considerCheckin, instance);

				// FIX: Now you cannot select a shorter length of stay than the number of days for the variant.
				if (selectDates.selected.length !== days) {
					self.activeReservation(_selector, false, []);
					return;
				}

				self.selectElements(
					selectDates.isAvailable,
					selectDates.selected,
					instance,
					"click"
				);

				self.activeReservation(
					_selector,
					selectDates.isAvailable,
					selectDates.selected
				);
			},
			onMonthChange: function (selectedDates, dateStr, instance) {
				self.hoverEvent(days, available, checkin, checkout, considerCheckin, instance);
			},
			onDayCreate: function (dObj, dStr, fp, dayElem) {
				let instance = fp;
				let date = window.flatpickr.formatDate(
					dayElem.dateObj,
					instance.config.dateFormat
				);

				available.forEach(function (x, i) {
					if (x === date) {
						dayElem.classList.add("available");
					}
				});

				if (considerCheckin) {
					checkin.forEach(function (x, i) {
						if (x === date) {
							dayElem.classList.add("checkin");
						}
					});
				}

				unavailable.forEach(function (x, i) {
					if (x === date) {
						dayElem.classList.add("unavailable");
					}
				});

				checkout.forEach(function (x, i) {
					if (x === date) {
						dayElem.classList.add("checkout");
					}
				});

				selectable.forEach(function (x, i) {
					if (x === date) {
						dayElem.classList.add("selectable");
					}
				});
			},
			onReady: function (selectedDates, dateStr, instance) {
				// 17.1.2019 - disabled per Stepan request, will be reworked later
				//let html = `<ul class="c-datepicker-legend__list"><li class="c-datepicker-legend__item unavailable">${unavailableText}</li><li class="c-datepicker-legend__item sold">${soldDatesText}</li></ul>`;
				//document.querySelector('.c-datepicker-legend').innerHTML += html;

				this.calendarContainer.offsetParent.classList.add(
					"c-datepicker",
					"c-datepicker--reservation",
					"c-datepicker--inline",
					"c-datepicker--no-hover"
				);
				this.calendarContainer.classList.add("c-datepicker__inner");
				self.hoverEvent(days, available, checkin, checkout, considerCheckin, instance);

				let selectDates = self.selectDates(
					dateStr,
					days,
					available,
					checkin,
					checkout,
					considerCheckin,
					instance
				);

				// FIX: Now you cannot select a shorter length of stay than the number of days for the variant.
				if (selectDates.selected.length !== days) {
					return;
				}

				self.selectElements(
					selectDates.isAvailable,
					selectDates.selected,
					instance,
					"click"
				);
				self.activeReservation(_selector, false, selectDates.selected);
			},
			onOpen: function (selectedDates, dateStr, instance) {
				self.hoverEvent(days, available, checkin, checkout, considerCheckin, instance);

				let selectDates = self.selectDates(
					dateStr,
					days,
					available,
					checkin,
					checkout,
					considerCheckin,
					instance
				);

				// FIX: Now you cannot select a shorter length of stay than the number of days for the variant.
				if (selectDates.selected.length !== days) {
					return;
				}

				self.selectElements(
					selectDates.isAvailable,
					selectDates.selected,
					instance,
					"click"
				);
			},
		});
	}

	fetchDays(_selector) {
		const self = this;
		const selectbox = self._node.querySelector(_selector.dataset.selectboxId);

		if (!selectbox) {
			return Number(_selector.dataset.days);
		}

		const option = selectbox.options[selectbox.options.selectedIndex];
		_selector.dataset.days = Number(option.dataset.days);

		return Number(_selector.dataset.days);
	}

	hoverEvent(days, available, checkin, checkout, considerCheckin, instance) {
		const self = this;
		const daySelector = Array.prototype.slice.call(
			instance.calendarContainer.querySelectorAll(".flatpickr-day")
		);

		daySelector.forEach((x, i) => {
			x.addEventListener("mouseover", function (e) {
				if (!x.classList.contains("disabled")) {
					const selectedDate = window.flatpickr.formatDate(
						daySelector[i].dateObj,
						instance.config.dateFormat
					);

					const selectDates = self.selectDates(
						selectedDate,
						days,
						available,
						checkin,
						checkout,
						considerCheckin,
						instance
					);

					self.selectElements(
						selectDates.isAvailable,
						selectDates.selected,
						instance,
						"hover"
					);
				}
			});

			x.addEventListener("mouseleave", function (e) {
				daySelector.forEach((x) => {
					x.classList.remove("hover");
				});
			});
		});
	}

	selectDates(
		selectedDay,
		days,
		availableDays,
		checkinDays,
		checkoutDays,
		considerCheckIn,
		instance
	) {
		const self = this;
		let finalArray = [selectedDay];
		let isAvailable;
		let selectHasCheckout = checkoutDays.includes(selectedDay);

		// vstupne udaje su pocet dni a vybrany den
		for (var i = 1; i < days; i++) {
			let selectedDate = new Date(selectedDay);
			let nextDate = new Date(
				selectedDate.getTime() + 24 * 60 * 60 * (i * 1000)
			);
			let nextDateFormated = window.flatpickr.formatDate(
				nextDate,
				instance.config.dateFormat
			);
			let prevDayNum = 1;

			if (
				selectHasCheckout ||
				!availableDays.includes(nextDateFormated)
			) {
				// last day of selection
				if (checkoutDays.includes(nextDateFormated)) {
					finalArray.push(nextDateFormated);
					selectHasCheckout = true;
				} else {
					for (var j = i; j < days; j++) {
						let prevDate = new Date(
							selectedDate.getTime() -
							prevDayNum * 1000 * 60 * 60 * 24
						);
						let prevDateFormated = window.flatpickr.formatDate(
							prevDate,
							instance.config.dateFormat
						);

						if (availableDays.includes(prevDateFormated)) {
							finalArray.push(prevDateFormated);
							prevDayNum++;
						} else {
							break;
						}
					}

					break;
				}
			} else {
				finalArray.push(nextDateFormated);
			}
		}

		finalArray = finalArray.sort();

		isAvailable = finalArray.length === days ? true : false;

		// selected date is not in array
		// of checkin dates, do not allow hover (and thus no click?)
		if (isAvailable && considerCheckIn && !checkinDays.includes(finalArray[0])) {
			// console.log('does not include the date ' + finalArray[0]);
			isAvailable = false;
		} else {
			// console.log('includes ' + finalArray[0]);
			isAvailable = true;
		}

		return {
			selected: finalArray,
			isAvailable: isAvailable,
		};
	}

	selectElements(
		_isAvailable,
		_availableDates,
		_instance,
		_event
	) {
		const unformatedSelectedDays = [];
		const calendarDays = Array.prototype.slice.call(
			_instance.calendarContainer.querySelectorAll(".flatpickr-day")
		);

		if (_isAvailable) {
			_availableDates.forEach((x, i) => {
				const unformated = new Date(x);
				unformatedSelectedDays.push(unformated);
			});

			calendarDays.forEach((x, i) => {
				const formated = window.flatpickr.formatDate(
					x.dateObj,
					_instance.config.dateFormat
				);

				if (_availableDates.includes(formated)) {
					if (_event === "hover") {
						x.classList.add("hover");
					} else {
						x.classList.add("picked");
						_instance.selectedDates = unformatedSelectedDays;
					}
				}
			});
		}
	}

	activeReservation(_selector, _isAvailable, _availableDates) {
		const self = this;

		// save selected date to input
		self._calendarInput.value = _isAvailable ? _availableDates : "";
		self._calendarInput.dispatchEvent(new CustomEvent("change"));


		if (!_isAvailable) {
			self._calendarSurchargeInput.value = JSON.stringify(null);
			self._calendarSurchargeInput.dispatchEvent(new CustomEvent("change"));
			return;
		}

		// const url = new URL(_selector.dataset.surchargeUrl);
		//
		// url.searchParams.append("variantId", self._calendar.dataset.variant);
		// url.searchParams.append("booking_dates", _availableDates);
		//
		// if (self._calendar.dataset.rooms) {
		// 	url.searchParams.append("roomId", self._calendar.dataset.rooms);
		// }
		//
		// AjaxRequest.create(url.toString())
		// 	.then((result) => {
		// 		self._calendarSurchargeInput.value = JSON.stringify(result);
		// 		self._calendarSurchargeInput.dispatchEvent(new CustomEvent("change"));
		// 	})
		// 	.catch((err) => AjaxRequest.handleError(err));
	}

	submit() {
		let self = this;
		self._node.dispatchEvent(new CustomEvent("submit"));
	}

	forceSubmit() {
		let self = this;
		self._node.submit();
	}

	_bindEvents() {
		let self = this;

		self._node.addEventListener("submit", () => {
			self.forceSubmit();
		});
	}

	_initElements() {
		let self = this;

		DealTermChange.init(self);
	}

	getNode() {
		return this._node;
	}

	addElement(element, id = null) {
		let self = this;

		if (!id) {
			id = "__" + Object.keys(self._elements).length;
		}

		self._elements[id] = element;
	}

	callElementUpdate(element, customData) {
		let self = this;
		let data =
			typeof customData === "undefined" ? element.getData() : customData;
		let req;

		if (data === null || data === false) {
			req = self._callElementDeleteValue(element);
		} else {
			req = self._callElementStoreValue(element, data);
		}

		self._validationRequests.push(req);
	}

}

const dealChangeForms = document.querySelectorAll(".js-deal-change-form");

dealChangeForms.forEach(form => {
	const dealChange = new DealChangeForm();
	dealChange.init(form);
})
